import styled from 'styled-components';
import Colors from 'pubweb-smokey/dist/colors.js';

const StyledWelcomeHomeGallery = styled.section``;

export default StyledWelcomeHomeGallery;
